// Only enable live reload when running on localhost
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  new EventSource(`${SERVE_ORIGIN}/esbuild`).addEventListener("change", () =>
    location.reload()
  );
} else {
  // console.log("Live reload disabled: not running on localhost");
}
